import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import colors from "@constants/colors"
import { columns14 } from "@constants/layout"
import measurements from "@constants/measurements"
import { smallcaps, h3, h4 } from "@constants/typography"
import ProductStyleCard, {
  ProductStyleCardProps,
} from "@components/ProductStyleCard"
import Scrollbar, {
  Container as ScrollbarContainer,
} from "@components/Scrollbar"
import VerticalSpace from "@components/VerticalSpace"
import { MobileOnly } from "@utils/MediaQueries"

const Container = styled.div`
  ${ScrollbarContainer} {
    padding: 0 20px;
  }
`

const Header = styled.div`
  padding: 20px 20px 0 20px;

  ${up("laptop")} {
    padding: 0 ${columns14(1)};
  }

  ${up("maxWidth")} {
    max-width: ${measurements.MAX_WIDTH};
    margin: 0 auto;
    padding: 0;
  }
`

const Title = styled.div`
  ${h4};
  margin: 0;
  font-size: 24px;
  color: ${colors.obsidian};

  ${up("laptop")} {
    ${h3};
    color: ${colors.obsidian};
  }
`

const Subtitle = styled.div`
  ${smallcaps}
  font-size: 14px;
  color: ${colors.obsidian};

  ${up("laptop")} {
    font-size: 16px;
    color: ${colors.obsidian};
  }
`

const Content = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
  padding-left: 20px;

  ${up("laptop")} {
    flex-wrap: wrap;
    margin: 0 auto;
    padding: 0 ${columns14(1)};
  }

  ${up("maxWidth")} {
    max-width: ${measurements.MAX_WIDTH};
    padding: 0;
  }
`

const CardWrapper = styled.div`
  display: inline-flex;
  width: 144px;
  min-height: 176px;
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 8px;

  ${up("laptop")} {
    margin-right: 12px;
    margin-bottom: 12px;
  }
`

const Spacer = styled.div`
  flex-shrink: 0;
  width: 10px;
  height: auto;
`

// mobile Safari PLEASE
const MobileSafariScrollbarHider = styled.div`
  z-index: 10;
  width: 100%;
  height: 20px;
  background-color: ${colors.snow};
`
interface ProductStyleProps {
  productStyles: Array<ProductStyleCardProps>
  onClick?: (title) => void
  type?: string
}

const ProductStyles: React.FC<ProductStyleProps> = ({
  productStyles,
  onClick,
  type = "Style",
}) => {
  const contentRef = React.createRef<HTMLDivElement>()

  // console.log(productStyles)

  return (
    <Container>
      <Header>
        <Subtitle>Filter Search By</Subtitle>
        <Title>Seat {type}</Title>
        <VerticalSpace height={20} mobileHeight={20} />
      </Header>
      <Content ref={contentRef}>
        {productStyles.map((productStyle, index) => (
          <CardWrapper key={"style-" + index}>
            <ProductStyleCard {...productStyle} onClick={onClick} />
          </CardWrapper>
        ))}
        <Spacer />
      </Content>
      <MobileOnly>
        <Scrollbar containerRef={contentRef} />
        <MobileSafariScrollbarHider />
      </MobileOnly>
    </Container>
  )
}

export default ProductStyles
